import { ChangeDetectionStrategy, Component, inject, effect, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { isRtlLanguage } from '@core/utils/rtl.util';
import { AppStore } from '@core/states/app/app.store';
import { FingerprintService } from '@core/services/fingerprint.service';


@Component({
  selector: 'ub-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col h-screen'
  },
  imports: [
    RouterOutlet,
  ]
})
export class AppComponent implements OnInit {

  public readonly appStore = inject(AppStore);

  public readonly year = new Date().getFullYear();
  public readonly fingerprint = signal<string>('');

  constructor(
    protected readonly transloco: TranslocoService,
    protected readonly fingerprintService: FingerprintService
  ) {
    effect(
      () => {
        const lang = this.transloco.getActiveLang();
        const isRtl = isRtlLanguage(lang);
        
        document.documentElement.dir = isRtl? 'rtl' : 'ltr';
        document.documentElement.lang = lang;
      }
    );
  }

  public ngOnInit(): void{
    this.fingerprintService.getFingerprint().then(
      (fp) => this.fingerprint.set(fp)
    );
  }
}
